import "./common/lib/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./common/locales/i18n";
import "./globals.css";
import { App } from "./app";

// biome-ignore lint/style/noNonNullAssertion: root is always defined
createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
